import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from './toast.service';

/**
 * Renders the confirmation toasts (ToastService). The app shell holds exactly one, after the frame.
 * The stack is one polite live region, so each new sentence is read once. Hovering it or moving
 * focus into it (to reach Undo) pauses every toast's timer.
 */
@Component({
  selector: 'app-toast-stack',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './toast-stack.component.html',
  styleUrls: ['./toast-stack.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastStackComponent {
  protected readonly service = inject(ToastService);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private hovered = false;
  private focused = false;

  protected onPointer(inside: boolean): void {
    this.hovered = inside;
    this.sync();
  }

  protected onFocusIn(): void {
    this.focused = true;
    this.sync();
  }

  protected onFocusOut(event: FocusEvent): void {
    const next = event.relatedTarget as Node | null;
    this.focused = !!next && this.host.nativeElement.contains(next);
    this.sync();
  }

  private sync(): void {
    if (this.hovered || this.focused) this.service.pause();
    else this.service.resume();
  }
}
